/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";

import sweetalert from "sweetalert";
import { useApolloClient } from "@apollo/client";
import { useNavigate, useLocation } from "react-router-dom";

import { getUser, getToken, isAuthenticated, logout as logoutUser } from "./../services/auth";

import USER_INFO from "../provider/Users/query";

export const UsersContext = React.createContext<iUserContext | null>(null);

export const UsersProvider = (props: any) => {
  const apollo = useApolloClient();
  const navigate = useNavigate();
  const location = useLocation();

  const is_callcenter = getUser()?.is_callcenter;
  const franchise_id = getUser()?.franchise?.id;

  const loadUser = React.useCallback(() => {
    if (getToken()) {
      apollo
        .query({ query: USER_INFO, variables: { id: parseInt(`${getUser()?.id}`) } })
        .then(info => {
          if (!info.data) {
            logout();
            sweetalert({
              title: "Sessão Expirada!",
              text: "Refaça o login para acessar o sistema",
            });
            navigate("/login");
          }
        })
        .catch(error => {
          if (error.status === 401) {
            logout();
            sweetalert({
              title: "Sessão Expirada!",
              text: "Refaça o login para acessar o sistema",
            });
            navigate("/login");
          }
        });
    } else if (location.pathname !== "/register") {
      logout();
      sweetalert({
        title: "Sessão Expirada!",
        text: "Refaça o login para acessar o sistema",
      });
      navigate("/login");
    }
  }, [getUser]);

  const logout = React.useCallback(() => {
    logoutUser();
    
    if (is_callcenter && franchise_id) {
      navigate(`/callcenter/${franchise_id}`, { replace: true });
    } else {
      navigate("/login", { replace: true });
    }

    return true;
  }, [getUser]);

  React.useEffect(() => {
    if (
      !location.pathname.includes('/login') &&
      location.pathname !== "/error" &&
      location.pathname !== "/politica-de-privacidade" &&
      location.pathname !== "/notfound" &&
      !location.pathname.includes('/callcenter') &&
      location.pathname !== "/access"
    ) {
      loadUser();
    }
  }, []);
  return <UsersContext.Provider value={{ getUser, getToken, logout, isAuthenticated }}>{props.children}</UsersContext.Provider>;
};

export const useUser = () => React.useContext<iUserContext | null>(UsersContext);
